
import { computed, defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'DateInput',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object as PropType<string[]>,
      default: () => ({})
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxDate: {
      type: Date,
      default: null
    }
  },
  emits: ['update:modelValue'],
  setup (props) {
    const formattedMaxDate = computed(() => {
      if (props.maxDate) {
        const year = props.maxDate.getFullYear()
        const month = String(props.maxDate.getMonth() + 1).padStart(2, '0')
        const day = String(props.maxDate.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      }
      return null
    })

    return {
      formattedMaxDate
    }
  }
})

